<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.invoice.createCompanyInvoice')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">

                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

                <div class="card">
                    <div class="card-header bg-light">
                        <div class="card-title">{{$t('form.invoice.createCompanyInvoice')}}</div>
                        <button class="btn btn-primary float-right"
                            v-on:click="invoiceCreate()">{{$t('button.save')}}</button>
                    </div>

                    <div class="card-body">

                        <div class="form-group">
                            <label for="InvoiceNumber">{{$t('form.invoice.invoiceNumber')}} <span
                                    class="text-danger">*</span></label>
                            <div>
                                <input id="InvoiceNumber" type="text" v-model="company_invoice.InvoiceNumber"
                                    class="form-control" data-role="text" name="InvoiceNumber" readonly="readonly">
                            </div>
                        </div>

                        <div class="form-group">
                            <label for="Student">{{$t('form.invoice.companyName')}} <span
                                    class="text-danger">*</span></label>

                            <v-select label="CompanyName" :options="companies" v-model="company_invoice.CompanyID"
                                :reduce="companies => companies.ID"></v-select>

                            <div class="invalid-feedback custom-validate" v-if="invalidCompany">
                                {{$t('form.validation.required')}}
                            </div>
                        </div>

                        <div class="form-group">
                            <label for="InvoicePurpose">{{$t('form.invoice.invoicePurpose')}} <span
                                    class="text-danger">*</span></label>
                            <div>
                                <input id="InvoicePurpose" v-model.trim="$v.company_invoice.InvoicePurpose.$model"
                                    :class="{ 'is-invalid': $v.company_invoice.InvoicePurpose.$error }"
                                    name="InvoicePurpose" class="form-control">
                                <div class="invalid-feedback" v-if="!$v.company_invoice.InvoicePurpose.required">
                                    {{$t('form.validation.required')}}</div>
                                <div class="invalid-feedback" v-if="!$v.company_invoice.InvoicePurpose.maxLength">
                                    {{$t('form.validation.maxLength', {num: $v.company_invoice.InvoicePurpose.$params.maxLength.max})}}
                                </div>
                            </div>
                        </div>

                        <div class="form-group">
                            <label for="Amount">{{$t('form.invoice.amount')}}<span class="text-danger">*</span></label>
                            <div>
                                <input id="Amount" v-model.trim="$v.company_invoice.Amount.$model"
                                    :class="{ 'is-invalid': $v.company_invoice.Amount.$error }" name="Amount"
                                    type="text" class="form-control">
                                <div class="invalid-feedback" v-if="!$v.company_invoice.Amount.required">
                                    {{$t('form.validation.required')}}</div>
                                <div class="invalid-feedback" v-if="!$v.company_invoice.Amount.decimal">
                                    {{$t('form.validation.decimalAllowed')}}
                                </div>
                                <div class="invalid-feedback" v-if="!$v.company_invoice.Amount.maxLength">
                                    {{$t('form.validation.maxLength', {num: $v.company_invoice.Amount.$params.maxLength.max})}}
                                </div>
                            </div>
                        </div>

                        <div class="form-group">
                            <label for="Currency">{{$t('form.invoice.currency')}} <span
                                    class="text-danger">*</span></label>
                            <div>
                                <v-select :options="currencies" v-model.trim="$v.company_invoice.Currency.$model"
                                    :reduce="currencies => currencies">
                                </v-select>

                                <div class="invalid-feedback custom-validate" v-if="invalidCurrency">
                                    {{$t('form.validation.required')}}</div>
                            </div>
                        </div>

                        <div class="form-group">
                            <label for="field127">{{$t('form.invoice.invoiceDate')}} <span
                                    class="text-danger">*</span></label>
                            <date-picker :lang="lang" class="date-picker" v-model="company_invoice.InvoiceDate" valueType="format"
                                :format="dateFormat" :popup-style="{ top: '100%', left: 0}" :append-to-body="false">
                            </date-picker>
                            <div class="invalid-feedback custom-validate" v-if="invalidDate">
                                {{$t('form.validation.required')}}</div>
                        </div>

                        <div class="form-group">
                            <label for="field125">{{$t('form.invoice.dueDate')}} <span
                                    class="text-danger">*</span></label>
                            <date-picker :lang="lang" class="date-picker" v-model="company_invoice.DueDate" valueType="format"
                                :format="dateFormat" :popup-style="{ top: '100%', left: 0}" :append-to-body="false">
                            </date-picker>
                            <div class="invalid-feedback custom-validate" v-if="invalidDue">
                                {{$t('form.validation.required')}}</div>
                        </div>

                        <div class="form-group">
                            <label>
                                <input type="checkbox" value="-1" @change="changeCheck($event)"
                                    v-model="company_invoice.Paid" /> {{$t('form.invoice.paid')}}
                            </label>
                        </div>

                        <div class="form-group">
                            <label for="field126">{{$t('form.invoice.paymentDate')}} </label>
                            <date-picker :lang="lang" class="date-picker" v-model="company_invoice.PaymentDate" valueType="format"
                                :format="dateFormat" :popup-style="{ top: '100%', left: 0}" :append-to-body="false">
                            </date-picker>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        required,
        minLength,
        maxLength,
        decimal,
        alpha
    } from "vuelidate/lib/validators";

    export default {
        props: ['permissions', 'dateFormat', 'datetimeFormat'],

        data() {
            return {
                alert: false,
                alertClass: '',
                alertMessage: '',

                isLoading: false,
                fullPage: true,

                request_source: '',
                invalidCurrency: false,
                invalidCompany: false,
                invalidDate: false,
                invalidDue: false,
                lang: {
                    formatLocale: {
                        firstDayOfWeek: 1,
                    },
                },
                company_invoice: {
                    CompanyID: null,
                    InvoicePurpose: null,
                    InvoiceNumber: null,
                    Amount: null,
                    Currency: null,
                    InvoiceDate: moment().format(this.dateFormat),
                    DueDate: null,
                    PaymentDate: null,
                    Paid: null,
                },

                currencies: [],
                companies: []
            }

        },
        validations: {
            company_invoice: {
                InvoicePurpose: {
                    required,
                    maxLength: maxLength(255)
                },
                Amount: {
                    required,
                    maxLength: maxLength(100),
                    decimal
                },
                Currency: {
                    required
                },
                InvoiceDate: {
                    required
                },
                DueDate: {
                    required
                }
            }
        },

        mounted() {
            if (!this.permissions.createInvoicesCompanies) {
                return this.$router.push('/');
            }

            this.getInitialData();
        },

        methods: {

            getInitialData() {
                this.isLoading = true;

                axios
                    .get('/api/invoices/get-initial-data')
                    .then(response => {
                        this.isLoading = false;

                        this.company_invoice.InvoiceNumber = response.data.invoice_number;
                        this.company_invoice.Amount = response.data.amount;
                        this.company_invoice.Currency = response.data.default_currency;
                        this.company_invoice.DueDate = this.getDueDate(response.data.due_date_duration);

                        this.currencies = response.data.currencies;
                        this.companies = response.data.companies;
                    })
                    .catch(error => {
                        this.isLoading = false;
                        console.log('error');
                    });
            },

            getDueDate(days) {
                days = parseInt(days);
                return moment().add(days, 'days').format(this.dateFormat);
            },

            invoiceCreate() {

                this.$v.$touch();

                if (this.company_invoice.Currency == null) {
                    this.invalidCurrency = true;
                } else {
                    this.invalidCurrency = false;
                }

                if (this.company_invoice.CompanyID == null) {
                    this.invalidCompany = true;
                } else {
                    this.invalidCompany = false;
                }

                if (this.$v.$invalid || this.invalidCompany) {


                      let errorMsg = '';

                     if(this.invalidCompany){
                        errorMsg = errorMsg ? errorMsg +", "+this.$t('form.invoice.companyName'): this.$t('form.invoice.companyName');
                    };


                    if(this.$v.company_invoice.InvoicePurpose.$error){
                        errorMsg = errorMsg ? errorMsg +", "+this.$t('form.invoice.invoicePurpose'): this.$t('form.invoice.invoicePurpose');
                    };

                    if(this.$v.company_invoice.Amount.$error){
                        errorMsg = errorMsg ? errorMsg +", "+this.$t('form.invoice.amount'): this.$t('form.invoice.amount');
                    };

                    if(this.$v.company_invoice.Currency.$error){
                        errorMsg = errorMsg ? errorMsg +", "+this.$t('form.invoice.currency'): this.$t('form.invoice.currency');
                    };

                    if(this.$v.company_invoice.InvoiceDate.$error){
                        errorMsg = errorMsg ? errorMsg +", "+this.$t('form.invoice.invoiceDate'): this.$t('form.invoice.invoiceDate');
                    };
 
                    if(this.$v.company_invoice.DueDate.$error){
                        errorMsg = errorMsg ? errorMsg +", "+this.$t('form.invoice.dueDate'): this.$t('form.invoice.dueDate');
                    };
            
                       this.showAlert(this.$t('form.validation.mandatoryFieldsError', {errors:errorMsg}), 'danger');
                    return;
                } else {
                    this.isLoading = true;

                    let data = {
                        ...this.company_invoice
                    };

                    if (data.InvoiceDate)
                        data.InvoiceDate = moment(data.InvoiceDate, this.dateFormat).format('YYYY-MM-DD');

                    if (data.DueDate)
                        data.DueDate = moment(data.DueDate, this.dateFormat).format('YYYY-MM-DD');

                    if (data.PaymentDate)
                        data.PaymentDate = moment(data.PaymentDate, this.dateFormat).format('YYYY-MM-DD');

                    axios
                        .post('/api/companyinvoices', data)
                        .then(response => {
                            this.isLoading = false;

                            if (response.data.success) {
                                this.showAlert(response.data.message);

                                setTimeout(() => {
                                    this.$router.push({
                                        name: 'CompanyInvoiceIndex'
                                    });
                                }, 2000);
                            }

                            if (response.data.error) {
                                this.showAlert(response.data.message, 'danger');
                            }

                        }, error => {
                            this.isLoading = false;
                            console.log('error');
                        });
                }
            },

            changeCheck($event) {
                if (event.target.value == "-1")
                    event.target.value = "1";
                else
                    event.target.value = "-1";
            },

            showAlert(msg, cls = 'success') {
                this.alertMessage = msg;
                this.alertClass = cls;
                this.alert = true;
            }

        }
    }

</script>
<style scoped>
    .custom-validate {
        display: block !important;
    }

</style>
